import { Delete, Email, Info, Phone } from '@mui/icons-material'
import { Card, CardContent, CardHeader, Chip, Grid, IconButton, Tooltip, Typography } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography'
import { useArgonController } from 'context'
import Tambah from 'pages/superAdmin/DaftarOpd/Tambah'
import { Link } from 'react-router-dom'

const OpdCardAdmin = ({
    data,
    addReq,
    decryptedUser,
    updating,
    setUpdating,
    hapus
}) => {
    const [controller] = useArgonController();
    const { darkMode } = controller;
    return (
        <Card>
            <CardHeader
                sx={{
                    pb: '0rem'
                }}
                title={

                    <ArgonBox>
                        <ArgonTypography
                            variant="h6"
                            textTransform="uppercase"
                            color={darkMode ? 'white' : 'dark'}
                            fontWeight='bold'
                        >
                            {data.nama_pd}
                        </ArgonTypography>
                        <Typography
                            variant="button"
                            color='text'
                        >
                            {data.kd_pd || 'Tidak ada Data Alamat'}
                        </Typography>
                    </ArgonBox>
                }
                action={
                    <>
                        <Tooltip title="Detail">
                            <IconButton aria-label="detail" color="info" component={Link} to={"/admin/opd/detail"} state={data}>
                                <Info />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete">
                            <IconButton aria-label="delete" color="error" onClick={() => hapus(data.kd_pd)}>
                                <Delete />
                            </IconButton>
                        </Tooltip>
                        <Tambah
                            decryptedUser={decryptedUser}
                            updating={updating}
                            setUpdating={setUpdating}
                            addReq={addReq}
                            editData={{
                                isEnable: true,
                                data: data
                            }}
                        />

                    </>
                }
            />
            <CardContent
                sx={{
                    pl: '1rem',
                    pt: '0rem'
                }}
            >
                <Grid container alignItems="center">
                    <Grid item xs={12}>
                        <ArgonBox lineHeight={2}>
                            <Typography
                                variant="subtitle2"
                                color='text'
                                fontWeight='bold'
                                sx={{
                                    opacity: 0.7
                                }}
                            >
                                {data.nama_pimpinan || 'Tidak ada Data Pimpinan'}
                            </Typography>
                        </ArgonBox>
                    </Grid>
                    <Grid item xs={12}>
                        <ArgonBox lineHeight={2}>
                            <Typography
                                variant="button"
                                color='text'
                            >
                                {data.alamat || 'Tidak ada Data Alamat'}
                            </Typography>
                        </ArgonBox>
                    </Grid>
                    <Grid item xs={12}>
                        <Chip icon={<Email />} label={data.email || 'Tidak ada Data Email'} color='primary' variant="outlined" /> <Chip icon={<Phone />} label={data.tlp || 'Tidak ada Data Telp'} color='primary' />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

export default OpdCardAdmin